import { Column, DataTable, Footer } from "@/components/data-table";
import { getMontoMonedaCantidad, getTotalMonedaTransferencia } from "@/features/monetizacion/shared/utils";
import { formatDate, formatNumber } from "@/shared/formats";
import { CajaMovimiento } from "@/shared/types/caja-movimiento";
import { TransferenciaItem } from "@/shared/types/transferencia";
import { Stack, StackProps, Typography } from "@mui/material";
import useGetMonedasOfTransferencia from "../hooks/use-get-monedas-of-transferencia";
import useMonetizacion from "@/features/monetizacion/hooks/use-monetizacion";

export interface SharedViewCajaMovimientoProps extends StackProps {
    cajaMovimiento: CajaMovimiento
}

export default function SharedViewCajaMovimiento({ cajaMovimiento, ...props }: SharedViewCajaMovimientoProps) {
    const monedas = useGetMonedasOfTransferencia(cajaMovimiento.transferencia);
    const { monedaBase } = useMonetizacion();

    return <Stack gap={3} {...props}>
        <Stack gap={2}>
            <Typography><b>Fecha/Hora:</b> {formatDate(cajaMovimiento.fecha, true)}</Typography>
            <Typography><b>Motivo:</b> {cajaMovimiento.descripcion}</Typography>
            <Typography><b>Total:</b> {formatNumber(cajaMovimiento.total)} {monedaBase.simbolo}</Typography>
        </Stack>
        <DataTable>
            <DataTable.Content
                columns={[
                    { header: "Forma de Pago", render: md => md.transferenciaMetodoNombre },
                    ...monedas.map<Column<TransferenciaItem>>(m => ({
                        header: <Typography variant="inherit" color={m.hidden ? "textDisabled" : "textPrimary"}>
                            Monto ({m.simbolo})
                        </Typography>,
                        render: row => <Typography variant="inherit" color={m.hidden ? "textDisabled" : "textPrimary"}>
                            {formatNumber(getMontoMonedaCantidad(row.monto, m.id))}
                        </Typography>,
                        width: "auto",
                        align: "right",
                    }))
                ]}
                rows={cajaMovimiento.transferencia.items}
                footers={[
                    { render: () => <Typography variant="subtitle1">Total</Typography> },
                    ...monedas.map<Footer>(m => ({
                        render: () => <Typography variant="subtitle2" color={m.hidden ? "textDisabled" : "textPrimary"}>
                            {formatNumber(getTotalMonedaTransferencia(cajaMovimiento.transferencia, m.id))}
                        </Typography>,
                        align: "right",
                    }))
                ]}
            />
        </DataTable>
    </Stack>
}